<template>
    <b-modal v-model="modalShow" ref="modal-pay-installment" size="lg" title="Pagar Parcela">
        <b-form novalidate="novalidate" autocomplete="off">
            <h5>
                <b-button variant="success" @click="addPayInstallment()">Adicionar</b-button>
            </h5>
            <div class="row"
                 v-show="form.payments.length > 0"
                 v-for="iterator in form.payments">
                <div class="col-md-3">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger' : validation.type_of_payment != ''}">
                        <label for="type_of_payment" class="bmd-label-floating">Forma de Pagamento</label>
                        <model-list-select 
                            class="form-control"
                            :list="type_of_payments"     
                            option-value="id"
                            option-text="name"
                            v-model="iterator.type_of_payment_id"
                            placeholder="Escolha a forma">
                        </model-list-select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group bmd-form-group"
                         v-bind:class="{'is-filled': true}">
                        <label for="pay_at" class="bmd-label-floating">Data</label>
                        <date-picker v-model="iterator.pay_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group bmd-form-group"
                         v-bind:class="{'is-filled': true}">
                        <label for="value" class="bmd-label-floating">Valor Pago</label>
                        <money v-model="iterator.value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                    </div>
                </div>
                <div class="col-md-2">
                    <b-button block variant="danger" @click="removePayInstallment(iterator)">Remover</b-button>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitPayInstallment" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button> 
        </div>
    </b-modal>
</template>
<script>
    import Vue from 'vue';
    import ValidationService from '@/services/validations.service';

    export default {
        computed: {
            type_of_payments: {
                set(_typeOfPayments) {

                },
                get() {
                    return this.$store.state.type_of_payments.itens;
                }
            }
        },
        data() {
            return {
                form: {
                    id: 0,
                    installment_id: 0,
                    payments: [{
                            type_of_payment_id: null,
                            value: 0,
                            pay_at: new Date()
                        }]
                },
                modalShow: true,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                validation: {
                    type_of_payment: ''
                }
            };
        },
        mounted() {
            var self = this;

            self.form.id = self.$route.params.id;
            self.form.installment_id = self.$route.params.installment;

            if (self.type_of_payments.length == 0) {
                self.getDataTypeOfPayments();
            }

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });
        },
        methods: {
            addPayInstallment() {
                var payInstallment = {
                    type_of_payment_id: null,
                    value: 0,
                    pay_at: new Date()
                };

                this.form.payments.push(payInstallment);
            },
            goBack() {
                var self = this;
                self.$store.dispatch('proposals/get', self.$route.params.id);
                self.$router.push({'name': 'proposals.show', params: {'id': self.$route.params.id}});
            },
            onSubmitPayInstallment(_ev) {
                _ev.preventDefault();
                var self = this;

                var proposalPayment = {
                    id: this.form.id,
                    installment_id: this.form.installment_id,
                    payments: []
                };

                var payments = [];
                for (var i = 0; i < self.form.payments.length; i++) {
                    var payment = self.form.payments[i];
                    if (payment.pay_at != null && payment.type_of_payment_id != null && payment.value > 0) {
                        proposalPayment.payments.push({
                            pay_at: Vue.moment(payment.pay_at).format('YYYY-MM-DD'),
                            value: payment.value,
                            type_of_payment_id: payment.type_of_payment_id
                        });
                    }
                }

                if (proposalPayment.payments.length == 0) {
                    self.$notify.error("Favor fornecer os dados dos pagamentos!");
                } else {
                    self.$root.$emit("onLoading");
                    const response = self.$store.dispatch('proposals/pay_installment', proposalPayment);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Pagamento efetuado com sucesso!");
                        self.goBack();
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                        self.$notify.error("Não foi possivel efetuar o pagamento da parcela, tente novamente!");
                    });
                }
            },
            removePayInstallment(_payInstallment) {
                var self = this;
                self.$dialog.confirm("Deseja realmente remover o pagamento?")
                        .then(function () {
                            var paymentIndex = self.form.payments.indexOf(_payInstallment);
                            self.form.payments.splice(paymentIndex, 1);
                        });
            },
            async getDataTypeOfPayments() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('type_of_payments/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
        }
    };
</script>